import { SelfScheduledPeriodCount } from "api/hooks/private/users/students/CountSelfSchedulePeriods";
import { PickersDay, PickersDayProps } from "@mui/x-date-pickers/PickersDay";
import { PaletteColor, useTheme } from "@mui/material/styles";
import { Dayjs } from "dayjs";

interface PropTypes extends PickersDayProps<Dayjs> {
    coursePeriodCount?: SelfScheduledPeriodCount;
    studentBookedDates?: string[];
}

function CalendarDay(props: PropTypes) {
    const theme = useTheme();
    const { coursePeriodCount = [], studentBookedDates = [], day, outsideCurrentMonth, ...other } = props;
    const periodCount = (coursePeriodCount as SelfScheduledPeriodCount)[day.format('YYYY-MM-DD')];
    let color: PaletteColor | undefined = undefined;


    // set the background color for the day
    if (studentBookedDates.includes(day.format('YYYY-MM-DD'))) {
        color = theme.palette.primary;
    } else if (periodCount?.course_periods_with_open_performance_slots >= 2) {
        color = theme.palette.success;
    } else if (periodCount?.course_periods_with_open_performance_slots > 0) {
        color = theme.palette.warning;
    } else if (periodCount?.total_course_periods > 0 && periodCount?.course_periods_with_open_performance_slots === 0) {
        color = theme.palette.error;
    }

    return (
        // <Badge
        //     key={props.day.toString()}
        //     overlap="circular"
        //     badgeContent={periodCount?.total_course_periods}
        //     color="info"
        // >
        <PickersDay
            {...other}
            outsideCurrentMonth={outsideCurrentMonth}
            day={day}
            sx={{
                backgroundColor: color?.main,
                color: color?.contrastText ?? 'unset'
            }}
        />
        // </Badge>
    );
}

export default CalendarDay;